// extracted by mini-css-extract-plugin
export default {"two":"SecTwo_two__M7dyG","main":"SecTwo_main__D95+G","text":"SecTwo_text__ZeR6d","info":"SecTwo_info__z0TCF","up":"SecTwo_up__2AWDs","down":"SecTwo_down__OsENz"};